export const VIEWPORT_BREAKPOINTS = {
  compact: 380,
  mobile: 640,
  tablet: 900,
  desktop: 1200,
};

export const MOBILE_BREAKPOINT = VIEWPORT_BREAKPOINTS.mobile;

export function getViewportState(width, height) {
  const w = Number(width) || 0;
  const h = Number(height) || 0;
  return {
    width: w,
    height: h,
    isCompact: w > 0 && w <= VIEWPORT_BREAKPOINTS.compact,
    isMobile: w > 0 && w <= VIEWPORT_BREAKPOINTS.mobile,
    isTablet: w > VIEWPORT_BREAKPOINTS.mobile && w <= VIEWPORT_BREAKPOINTS.tablet,
    isDesktop: w > VIEWPORT_BREAKPOINTS.tablet,
  };
}

/** Sync fluid layout tokens whenever the viewport changes. */
export function applyViewportCssVars(width, height, el) {
  const target = el || (typeof document !== "undefined" ? document.documentElement : null);
  if (!target || !width) return;

  const w = Math.max(320, width);
  const h = Math.max(480, height || 0);
  const mobileScale = Math.min(1.08, Math.max(0.88, w / 390));
  const compactScale = Math.min(1, Math.max(0.82, w / 360));

  target.style.setProperty("--fx-vw", `${w}px`);
  target.style.setProperty("--fx-vh", `${h}px`);
  target.style.setProperty("--fx-mobile-scale", String(mobileScale.toFixed(3)));
  target.style.setProperty("--fx-compact-scale", String(compactScale.toFixed(3)));
  target.style.setProperty(
    "--fx-mobile-footer-height",
    `calc(clamp(44px, 11vw, 56px) + env(safe-area-inset-bottom, 0px))`
  );
}
